<template>
  <v-container>
    <h3>Miscellaneous Receipts</h3>
    <TransactionList/>
  </v-container>
</template>

<script>

import TransactionList from '@/components/Misc/Transaction/TransactionList.vue';

export default {
  name: 'MiscellaneousReceipts',
  components: {
    TransactionList,
  },
};
</script>
